import { defineComponent as s, inject as a, h as p } from "vue";
import { internalSelectionMenuInjectionKey as c } from "./ghl-ui.es1499.js";
import { render as f } from "./ghl-ui.es985.js";
const h = s({
  name: "NBaseSelectGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      renderLabelRef: d,
      renderOptionRef: n,
      labelFieldRef: o,
      nodePropsRef: r
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = a(c);
    return {
      labelField: o,
      nodeProps: r,
      renderLabel: d,
      renderOption: n
    };
  },
  render() {
    const {
      clsPrefix: d,
      renderLabel: n,
      renderOption: o,
      nodeProps: r,
      tmNode: {
        rawNode: e
      }
    } = this, t = r == null ? void 0 : r(e), i = n ? n(e, !1) : f(e[this.labelField], e, !1), l = p("div", Object.assign({}, t, {
      class: [`${d}-base-select-group-header`, t == null ? void 0 : t.class]
    }), i);
    return e.render ? e.render({
      node: l,
      option: e
    }) : o ? o({
      node: l,
      option: e,
      selected: !1
    }) : l;
  }
});
export {
  h as default
};
